import { ZyAsideIcon } from '@/components/tiptap-editor/tiptap-icons/zyaside-icon';
import { isSelectionTopNode } from '@/lib/zy-tiptap-utils';
import { forwardRef } from 'react';
import type { GenericExtensionButtonProps } from '../generic-extension-button';
import { GenericExtensionButton } from '../generic-extension-button';

const ZyAsideButton = forwardRef<
    HTMLButtonElement,
    Omit<GenericExtensionButtonProps, 'extensionName' | 'extensionType' | 'icon' | 'label' | 'command'>
>((props, ref) => (
    <GenericExtensionButton
        extensionName="zyAside"
        extensionType="node"
        icon={ZyAsideIcon}
        isDisabled={editor => !isSelectionTopNode(editor)}
        label="Insert zyAside"
        command={editor => editor.commands.insertZyAside()}
        ref={ref}
        id="zyaside-button"
        {...props}
    />
));

ZyAsideButton.displayName = 'ZyAsideButton';

export default ZyAsideButton;
